var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { Button, Flex, User } from "@gravity-ui/uikit";
import { PageBlock } from "@/components/ui/PageBlock";
import { getKeycloakInstance } from "@/context/shared/keycloak";
import { RoutesList } from "@/router/routesList";
export var ProfileDetails = function (props) {
    var _a = useState(false), isManager = _a[0], setIsManager = _a[1];
    useEffect(function () {
        var checkRole = function () { return __awaiter(void 0, void 0, void 0, function () {
            var keycloakInstance, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getKeycloakInstance()];
                    case 1:
                        keycloakInstance = _a.sent();
                        result = keycloakInstance.hasRealmRole("place-manager");
                        return [2 /*return*/, result];
                }
            });
        }); };
        checkRole().then(setIsManager);
    }, []);
    return (_jsxs(Flex, { direction: "column", gap: 6, children: [_jsxs(Flex, { direction: "column", gap: 4, children: [_jsx(User, { avatar: props.data.avatar
                            ? { imgUrl: props.data.avatar.url }
                            : { text: props.data.username, theme: "brand" }, name: props.data.username, size: "xl" }), _jsxs(Flex, { gap: 4, wrap: true, children: [_jsx(Button, { onClick: props.onEdit, size: "l", children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }), _jsx(Button, { onClick: props.logout, size: "l", children: "\u0412\u044B\u0439\u0442\u0438" }), !props.data.telegramId ? (_jsx(Button, { onClick: props.onLink, size: "l", children: "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C \u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C" })) : (_jsx(Button, { onClick: props.onUnlink, size: "l", children: "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C" }))] })] }), isManager && (_jsx(PageBlock, { isCard: true, children: _jsx(Link, { to: RoutesList.Manage.getManage(), children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435" }) }))] }));
};
